// eslint-disable-next-line no-unused-vars
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const StyledTableContainer = styled(({ ...rest }) => <div {...rest} />)`
    display: flex;
    overflow-x: ${({ overflowx = 'auto' }) => overflowx};
    ${({ bordertop }) =>
        bordertop &&
        css`
            border-top: ${bordertop};
        `}
`;

const StyledDataTable = styled(({ full, ...rest }) => <table {...rest} />)`
    border: 1px solid ${(props) => props.theme.colors.border.default};
    border-radius: 3px;
    border-spacing: 0;
    box-shadow: 0 2px 0 ${(props) => props.theme.colors.neutral.N1A};
    position: relative;
    min-height: 10rem;
    width: ${(props) => (props.full === 'true' ? `100%` : `auto`)};
`;

export const DataTableContainer = ({ children, displayLabel, id, label, overflowX, borderTop, ...props }) => {
    const a11yProps = {
        'aria-label': displayLabel ? undefined : label,
        'aria-labelledby': displayLabel ? id : undefined
    };
    const { fullWidth, ...otherProps } = props;

    return (
        <StyledTableContainer overflowx={overflowX} bordertop={borderTop}>
            <StyledDataTable {...a11yProps} {...otherProps} full={fullWidth === true ? 'true' : 'false'}>
                {children}
            </StyledDataTable>
        </StyledTableContainer>
    );
};

DataTableContainer.propTypes = {
    children: PropTypes.node.isRequired,
    displayLabel: PropTypes.bool,
    fullWidth: PropTypes.bool,
    id: PropTypes.string,
    label: PropTypes.string,
    overflowX: PropTypes.string,
    borderTop: PropTypes.string
};

DataTableContainer.defaultProps = {
    displayLabel: false,
    label: `Unlabelled Table`
};
